import React from 'react';

import { SectionWithTitle } from './base/Section';
import { InfoRow } from './base/InfoRow';
import { SummarySectionProps } from './types';

export const SummarySection: React.FC<SummarySectionProps> = ({
  effectiveDate,
  excludedDrivers,
  numberOfDrivers,
  numberOfVehicles,
  productName,
}) => {
  const showExcluded = Boolean(excludedDrivers);

  return (
    <SectionWithTitle title="Summary">
      <InfoRow label="Product" value={productName} />
      <InfoRow label="Effective" value={effectiveDate} />
      <InfoRow label="Number of vehicles" value={numberOfVehicles} />
      <InfoRow label="Number of drivers" value={numberOfDrivers} />
      {showExcluded && (
        <InfoRow label="Number of excluded drivers" value={excludedDrivers!} />
      )}
    </SectionWithTitle>
  );
};
